<template>
    <CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
        <template slot="header">
            <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Folio</th>
                <th :class="StyleTh">Cliente</th>
                <th :class="StyleTh">Total</th>
                <th :class="StyleTh">Forma de Pago</th>
                <th :class="StyleTh">Facturado</th>
                <th :class="StyleTh">Acciones</th>
                <th :class="StyleTh">Acuse de Cancelados</th>
                
        </template>

        <template slot="body">
            <tr v-for="(lista,index) in ListaArrayRows" :key="index">
                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
                <td><h6 :class="StylePr">{{lista.Folio+' - '+lista.Serie}}</h6></td>
                <td><p :class="StyleTd">{{lista.NombreCliente}}</p></td>
                <td><p :class="StyleTd">{{lista.Total}}</p></td>
                <td><p :class="StyleTd">{{lista.FormaPago}}</p></td>
                <td><p :class="StyleTd">{{lista.Facturado}}</p></td>
                    
                <td class="align-middle text-rigth">
                    <CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="false" :pId="lista.IdNotaCredito" :pEmitSeccion="ConfigList.EmitSeccion" :pGoRoute="ConfigList.GoRoute" :segurity="segurity">
                        <template slot="btnaccion">
                            <CMoreButtonsL>
                                <template slot="bodyBtnsL">
                                    <li @click="VerPdfFactura(lista)">
                                        <a class="dropdown-item">
                                            <i class="far fa-file-pdf"></i> Pdf
                                        </a>
                                    </li>

                                    <template v-if="lista.Facturado == 'SI'">
                                        <li @click="DescargarXml(lista)">
                                            <a class="dropdown-item">
                                                <i class="far fa-file-code"></i> Xml
                                            </a>
                                        </li>

                                        <li @click="VerPdfAcuse(lista)">
                                            <a class="dropdown-item">
                                                <i class="far fa-file-pdf"></i> Acuse de Cancelación
                                            </a>
                                        </li>

                                        <li>
                                            <a class="dropdown-item">
                                                <i class="far fa-exclamation-triangle"></i> Acuse de Cancelación
                                            </a>
                                        </li>
                                    </template>
                                </template>
                            </CMoreButtonsL>
                        </template>
                    </CBtnAccion>     
                </td>

                <td>
                    <p :class="StyleTd">{{lista.Folio}}</p>
                </td>
            </tr>
            <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="62"></CSinRegistros>
        </template>
    </CList>

</template>
<script>

import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionNotaCredito';

export default {
    name: 'ListaNotaCredito',
    props: ['sFiltros','pOrigen'],
    components: {
    },
    data() {
        return {
            ConfigList:{
                Title: 'Nota de Crédito',
                IsModal: false,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: '',
                GoRoute: 'notacreditoform',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("notasCredito",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('notasCredito/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus', params:{}});
        },
        VerPdfFactura(item)
        {
            this.ConfigList.ShowLoader = true;

            let newRequest = {
				IdNotaCredito: item.IdNotaCredito
			}

			this.$http.post('rptpdfCredito',newRequest).then((res)=>{     
				
				let pdfWindow = window.open("NotaCredito",'NotaCredito_'+item.IdNotaCredito,'_blank');
				pdfWindow.document.write(
					"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
					encodeURI(res.data.pdf) + "'></iframe>"
				);
                
			}).catch(err=>{   
				console.log(err);
			}).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        VerPdfAcuse(item)
        {
            this.ConfigList.ShowLoader = true;
            
            let newRequest = {
				IdDelCFDI: 17,//item.IdNotaCredito
				TipoDocumento: 'C',
			}

			this.$http.post('rptpdfacuse',newRequest).then((res)=>{     
				
				let pdfWindow = window.open("Acuse",'Acuse de cancelacion_'+item.IdNotaPago,'_blank');
				pdfWindow.document.write(
					"<iframe width='100%' height='100%' src='data:application/pdf;base64, " +
					encodeURI(res.data.pdf) + "'></iframe>"
				);
			}).catch(err=>{   
				console.log(err);
			}).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        CancelarFactura(item)
        {
            let obj = {
                IdDelCFDI: item.IdNotaPago,
                TipoCancelacion: 'C',
            };
            //this.bus.$emit('NewModal_'+EmitEjecuta2,obj);
        },
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
